import H4 from 'primitives/Typography/Headings/H4';
import styled from '@emotion/styled';

const Title = styled(H4)(({ theme }) => ({
  color: theme.colors.black.secondary,
  fontSize: '2.6rem',
  fontWeight: 700,
  lineHeight: '2.6rem',
  margin: '0 0 0.8rem',
}));

export default Title;
